import React from 'react';
import { toJS } from 'mobx';
import { inject, observer } from 'mobx-react';
import {
  Form, Input, Radio, Tooltip, Icon, DatePicker, Modal
} from 'antd'; 
import debounce from '../../../util/debounce';
import base from '../../../tool/base';
import isEmpty from 'lodash/isEmpty';

import dayjs from "dayjs";

import 'moment/locale/zh-cn';

import locale from 'antd/es/date-picker/locale/zh_CN';

const RadioGroup = Radio.Group;
const FormItem = Form.Item;
const { TextArea } = Input;
const store = ['caseListStore', 'initStore', 'modeListStore'];

@inject(...store)
@observer
class CaseApply extends React.Component {

  static defaultProps = {
    prefixCls: "app-apply-modal",
  }
  getHelpTip = (title, otherStyle = {}) => {
    const { prefixCls } = this.props;
    return (<div className={`${prefixCls}-help-tip`} style={otherStyle}>
      <Tooltip placement="right" title={title}>
        <Icon type="question-circle-o" />
      </Tooltip>
    </div>);
  }
  checkLicenseNull = (rule, value, callback) => {
    const { modeListStore: { isKbStatus } } = this.props;
    if(!value || value === '') {
      callback([new Error('授权用户码不能为空')]);
      return;
    }
    callback();
  }
  setRule = (status = true, value = "") => {
    const { form, modeListStore: { isKbStatus, setMobxState } } = this.props;
    isKbStatus !== status && setMobxState({isKbStatus: status});
    status && value !== "" && form.setFields({
      authKey: {
        errors: [new Error('该案例不支持当前系统KB')],
      },
    });
  }
  apply = () => {
    const { caseListStore: { temporaryAuth, apply }, form } = this.props;
    form.validateFields((errors, values) => {
      if (!errors && apply.authKey) {
        temporaryAuth(
          {
            authKey: apply.authKey.trim(),
            appId: apply.appId
          },
          data => Modal.info({
            title: '授权码',
            content: data.authCode
          })
        );
      }
    });
  }
  disabledDate = current => {
    return current && (current < dayjs().subtract(1, 'day') || current > dayjs().subtract(-89, 'day'));
  };
  render() {
    const { prefixCls, form, workflowChart,
      caseListStore: { 
        apply: {
          appId,
          title,
          ec,
          applyType,
          authKey,
          kb,
        },
        isPermissions
      },
    } = this.props;
    const { getFieldProps, getFieldValue, getFieldDecorator } = form;
    const layoutProps = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 6 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 18 },
      },
    };
    const today = new Date();
    const nextDate = new Date(today);
    nextDate.setDate(today.getDate() + 7);
    const dateTime = `${nextDate.getFullYear()}-${nextDate.getMonth() + 1}-${nextDate.getDate()}`;
    const ecCompatibility = ['E9'];
    return (
      <Form >
        <FormItem label="AppId ：" {...layoutProps} >
          <Input disabled {...getFieldProps('appId', { initialValue: appId })} />
        </FormItem>
        <FormItem label="应用名称 ：" {...layoutProps} >
          <Input disabled {...getFieldProps('title', { initialValue: title })} />
        </FormItem>
        {isPermissions || (
          <FormItem label="EC兼容 ：" {...layoutProps} >
            <RadioGroup className={`${prefixCls}-ecradio`} {...getFieldProps("ecCompatibility", {
              initialValue: ec
            })}>
              {
                ecCompatibility.map(sec => (<Radio.Button value={sec} key={sec}>{sec}</Radio.Button>))
              }
            </RadioGroup>
            {kb && <label style={{verticalAlign: 'middle'}}>{kb}</label>}
          </FormItem>
        )}
        {isPermissions || (
          <FormItem label="授权时间 ：" {...layoutProps}>
            <RadioGroup {...getFieldProps('applyType', {
              initialValue: applyType,
            })}>
              <Radio value="temporary">临时（7天）</Radio>
              <Radio value="permanent">永久</Radio>
            </RadioGroup>
            {this.getHelpTip(getFieldValue('applyType') === 'temporary' ? dateTime + "到期。" : "永久")}
          </FormItem>
        )}
        {isPermissions && (
          <FormItem label="授权有效期 ：" required {...layoutProps} className={`${prefixCls}-required`} >
            <DatePicker
              {...getFieldProps('expireDate', {
                rules: [{
                  required: true,
                }],
              })}
              locale={locale}              
              placeholder="请选择授权有效期"
              format="YYYY-MM-DD"
              disabledDate={this.disabledDate}
            />
            {this.getHelpTip("授权时间最长不能超过90天")}
          </FormItem>
        )}
        {isPermissions && (
          <FormItem label="订单号 ：" required {...layoutProps} className={`${prefixCls}-required`} >
            <Input
              {...getFieldProps('orderNum', {
                rules: [{
                  required: true,
                }],
              })}       
              placeholder="请填写订单号"
            />
          </FormItem>
        )}
        <FormItem label="授权用户码 ：" {...layoutProps} required className={`${prefixCls}-required`}>
          {getFieldDecorator("authKey", {
            initialValue: authKey,
            rules: [{
              validator: this.checkLicenseNull
            }],
          })(<AuthKeyTextArea kb={kb} setRule={this.setRule}/>)}
          {/* {this.getHelpTip("license，如果是存在多个license的集群环境，请用逗号隔开如license1,license2...", { top: '-70px' })} */}
          {isPermissions ? (
            <a onClick={() => window.open('https://e-cloudstore.com/doc.html?appId=237ca5e207a14e18b9afcf11667db280')}>开发授权说明</a>
          ) : (
            <a onClick={() => window.open('https://e-cloudstore.com/doc.html?appId=2997bd5a45de474db8d34034db8b4bb0')}>如何获取授权用户码？</a>
          )}
        </FormItem>
        {/* {!workflowChart && <FormItem  label="" {...layoutProps}>
          <Button onClick={this.apply}>申请开发权限</Button>
          <span style={{paddingLeft: 20, color: '#f00'}}>
            要求开发者拥有该应用的维护权限
          </span>
        </FormItem>} */}
      </Form>
    )
  }
}


class AuthKeyTextArea extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      authKey: this.props.value || ""
    }
  }
  getDetail = (params = {}) => {   //获取单个表单详情
    const { authKey } = this.state;
    const { setRule, kb } = this.props;
    const _authKey = authKey.trim();
    params = {
      authKey: _authKey,
      ...params,
    }
    if(!isEmpty(kb)) params.demoKb = kb;
    base.callApi('/v5/apply/checkApply', 'POST', params, 'json', 'text').then((data) => {
      if (data.data === 'y') {
        setRule && setRule(false, _authKey);
      } else {
        setRule && setRule(true, _authKey);
      }
    });
  }
  /**
   * 授权码输入改变事件
   * @param {object} e antd传入组件信息
   */
  authKeyChange = e => {
    const { onChange, value } = this.props;
    this.setState({authKey: e.target.value});
    debounce(this.getDetail, 700);
    onChange && onChange({
      ...value,
      ...e,
    })
  }
  render() {
    const { value } = this.props;
    return (
      <TextArea
        value={value}
        rows={5}
        onChange={this.authKeyChange}
      />
    )
  }

}

export default CaseApply;


// WEBPACK FOOTER //
// ./src/components/util/caseApply/CaseApply.js